import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import BrandedButton, {
  BrandedButtonProps,
} from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import { pushAdoptsOrderOriginalDeviationModal } from '../../Modals/redux/actionCreators';
import { useRestrictToLoggedIn } from '../../utils/hooks/useRestrictToLoggedIn';

interface Props extends Pick<BrandedButtonProps, 'className' | 'size'> {
  deviation: PapiDeviation;
}

export const RequestOriginalButton: React.FC<Props> = ({
  deviation,
  className,
  size,
}) => {
  const { t } = useTranslation();
  const { restrictToLoggedIn } = useRestrictToLoggedIn();
  const dispatchPushAdoptsOrderOriginalDeviationModal = useAction(
    pushAdoptsOrderOriginalDeviationModal
  );

  const handleRequestClick = useCallback(() => {
    dispatchPushAdoptsOrderOriginalDeviationModal(deviation);
  }, [dispatchPushAdoptsOrderOriginalDeviationModal, deviation]);

  if (
    deviation.originals?.isOpen === false ||
    deviation.extended?.originals?.isOpen === false
  ) {
    return (
      <SolidButton
        className={className}
        variant="main"
        size={size}
        priority="secondary"
        rounded
        disabled
      >
        {t('originals.actions.requestOriginalClosed')}
      </SolidButton>
    );
  }

  return (
    <BrandedButton
      className={className}
      variant="originals"
      size={size}
      onClick={restrictToLoggedIn(
        ReferralType.ORIGINALS_REQUEST,
        handleRequestClick
      )}
    >
      {t('originals.actions.requestOriginal')}
    </BrandedButton>
  );
};
RequestOriginalButton.displayName = 'RequestOriginalButton';

export default RequestOriginalButton;
